import React from 'react';

import style from './SeoContent.module.scss';

interface ISeoContent {
  children: JSX.Element | JSX.Element[];
}

export const SeoContent: React.FC<ISeoContent> = ({ children }) => (
  <div className={style.seoWrapper}>{children}</div>
);
